<template>
  
  <section>
      <button v-if="step > 1" @click="stepBack" class="btn mb-3 mr-1 btn-primary">
          <i class="fa fa-arrow-left"></i>
        </button>

  
    <div v-if="step === 1"> 
  <ValidationObserver ref="form" v-slot="{ handleSubmit }">
    <Error_messages :error_message="messages.error" :success_message = "messages.success"/>

    <form class="mt-4" novalidate @submit.prevent="handleSubmit(onSubmit)">
      <ValidationProvider :name="inputType" rules="required" v-slot="{ errors }">
        <b-form-group v-if="inputType === 'phone'" label="Phone" label-for="phone" >  
          <!-- <vue-phone-number-input id="Phone" :rules="rules.phone" v-model="PhoneNumber" default-country-code="KW" @update="updatePhone" /> -->
          <phone-number
                    v-model="user.phone"
                    :errors.sync="phone_value_change" 
                  />
                  <p v-if="phone_value_change" class="text-danger">{{ phone_value_change }}</p>
        
        
        
        </b-form-group>
          
        <b-form-group v-else label="Email" label-for="email" >
            <b-form-input id="email" :class="'form-control mb-0' +(errors.length > 0 ? ' is-invalid' : '')"     type="email" placeholder="Enter your email..." v-model="user.email"></b-form-input>
            <div v-if="errors.length" class="invalid-feedback"> {{ errors[0] }} </div>
        </b-form-group>
            
            
          </ValidationProvider>

          <p @click="toggleInputType" style="cursor:pointer; width: fit-content;" class=" text-primary font-size-16 font-weight-bold mb-3">
            you have {{ inputType === 'phone' ? 'an email ?' : 'a phone number ?' }}
          </p>

      <div class="d-inline-block w-100">
        <b-spinner v-if="loading" variant="primary" class="float-right" label="Spinning"></b-spinner>
        <button v-else type="submit" class="btn btn-primary float-right">Reset Password</button>
      </div>
    </form>
  </ValidationObserver>

  <div class="sign-info">
  <span class="dark-color d-inline-block line-height-2">
    Do you have an account?
    <router-link to="/auth/sign-in1" class="iq-waves-effect pr-4">
      Sign in
    </router-link>
  </span>
  <social-login-form></social-login-form>
</div>
</div>
<div v-else-if="step === 2">
  <Step2 :email="user.email"
         :phone="user.phone"
         @setStep="setStep"
         @setCode="setCode" />
  </div>
<div v-else-if="step === 3">
  <Step3  :email="user.email"
          :phone="user.phone"
          :code="code" />
</div>


</section>
</template>

<script>
import Step2 from './SignUpSteps/Step2.vue';
import Step3 from './SignUpSteps/Step3.vue';
import SocialLoginForm from './SocialLoginForm'
import { mapGetters } from 'vuex'
import { sendCode } from '@/API/UsersAPIs';
import PhoneNumber from '@/components/PhoneNumber.vue';
import Error_messages from "@/helpers/error_messages.vue";
import { core } from '@/config/pluginInit';
export default {
  name: 'SignUp1Form',
  components: 
  { 
    PhoneNumber,
    SocialLoginForm,
    Step2,
    Step3, 
    Error_messages
  },
  props: ['formType'],
  computed: {
    ...mapGetters({
      users: 'Setting/usersState'
    })
  },
  data(){
    return{
      phone_value_change: '',
      step: 1,
      loading:false,
      PhoneNumber: '',
      isPhoneValid: false,
      inputType: 'email',
      code: null,
      messages: { error: "", success: "" },
      user: {phone: '', email: ''},
      rules: {email: 'required|email', phone: 'required'},
    }
  },
  mounted() {
  core.index();
},
  methods: {
    toggleInputType() {
      this.inputType = this.inputType === 'phone' ? 'email' : 'phone';
      this.changeChoice = this.inputType === 'phone' ? 'Enter your phone number to reset your password.' : 'Enter your email address to reset your password.';
      //  check if user choose phone input then set email to null and vice versa
      this.inputType === 'phone' ? this.user.email = null : this.user.phone = null;
    },
    
   async onSubmit () {
    if (this.inputType === 'phone') {
      if (this.phone_value_change) return; 

        this.user = { phone: this.user.phone.formattedNumber};
      } else if (this.inputType === 'email') {
        this.user = { email: this.user.email }; 
      }
    this.loading = true;
     try {
      await sendCode(this.user);
      this.loading = false;
      this.messages.error="";
          this.step = 2;
        }
        catch(error){
          this.messages.error = error.message === "Network Error" 
          ? error.message 
          : error.response.data.errors[this.inputType][0] 
    }finally{ this.loading = false }
    },
    setStep(step){
      this.step = step;
    },
    setCode(code){
      this.code = code;
    },
    stepBack(){
      if(this.step === 2){
        this.user.email = "";
        this.user.phone = "";
        this.step = 1;
      }
      if(this.step === 3){
        this.step = 2;
      }
    },
  }
}
</script>
